import * as _ from 'lodash-es';

import {
  ACTION_PUT_USER,
  ACTION_PUT_USER_SUCCESS,
  ACTION_PUT_USER_RESET,
  ACTION_PUT_USER_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';
import { enqueueSnackbarHandler } from '../Status';

import { Dispatch } from 'redux';

import { enqueueSnackbar } from '../Status';

/**
 * PUT User Request Action
 */
export function putSingle(userId: string, data: any) {
  return (dispatch: Dispatch, getState: Function) => {
    // Dispatch the api call request.
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `user/${userId}`,
        method: 'put',
        data: JSON.stringify(data),
        success: (response: any) => {
          if (response.type === 'error') {
            const errors = _.get(response, 'payload.payload', {});
            Object.keys(errors).forEach(function (item) {
              if (_.get(errors, item, false) === true) {
                dispatch(enqueueSnackbar(item, 'error'));
              }
            });
            dispatch(requestFailed(response));
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { updateUserSuccess: true },
              'success',
            );
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          const errors = _.get(error, 'payload', {});
          Object.keys(errors).forEach(function (item) {
            if (_.get(errors, item, false) === true) {
              dispatch(enqueueSnackbar(item, 'error'));
            }
          });
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_USER,
    payload: null,
  };
}

export function requestSuccess(responeJSON: object) {
  return {
    type: ACTION_PUT_USER_SUCCESS,
    payload: responeJSON,
  };
}

export function requestFailed(responeJSON: object) {
  return {
    type: ACTION_PUT_USER_FAILURE,
    payload: responeJSON,
  };
}

export function resetUpdate() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_PUT_USER_RESET,
      payload: null,
    });
  };
}
